import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { map } from 'rxjs/internal/operators/map';

import { ApiService } from 'src/app/@graphql/services/api.service';
import { SET_CUDS_ADJUSTMENT_NOTE } from '../../@graphql/operations/mutation';
import { CookieAuthService } from 'src/app/@shared/storage-variables/cookie-auth.service';

@Injectable({
  providedIn: 'root',
})
export class RefundsService extends ApiService {
  constructor(
    apollo: Apollo,
    private cookieAuthService: CookieAuthService,
  ) {
    super(apollo);
  }

  setCudsAdjustmentNote(
    refund_id: number,
    cuds: string,
    document_number: string,
    dian_code?: string,
  ) {
    const companyObject = this.cookieAuthService.getCompanyObject;
    const company = companyObject?.Id_company;
    return this.mutation(SET_CUDS_ADJUSTMENT_NOTE, {
      refund_id,
      cuds,
      document_number,
      dian_code: dian_code ?? null,
      company,
    }).pipe(
      map((result) => {
        return (result as { setCudsAdjustmentNote: boolean })
          .setCudsAdjustmentNote;
      }),
    );
  }
}
